import { Spinner, type SpinnerProps } from "@nextui-org/react";

type LoadingSpinnerProps = {
  className?: string;
  size?: SpinnerProps["size"];
  label?: string;
};

const LoadingSpinner = ({
  className,
  size = "lg",
  label,
}: LoadingSpinnerProps) => {
  return (
    <div className={className}>
      <Spinner size={size} label={label} />
    </div>
  );
};

export default LoadingSpinner;
